import { render } from "./ColorSwatch.vue?vue&type=template&id=da2794fc&scoped=true"
import script from "./ColorSwatch.vue?vue&type=script&lang=js"
export * from "./ColorSwatch.vue?vue&type=script&lang=js"

import "./ColorSwatch.vue?vue&type=style&index=0&id=da2794fc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dendro-plots/dendro-plots/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da2794fc"]])

export default __exports__